const projects = [
  {
    title: "Muse",
    desc: "A 9,000+ line full stack music review platform integrating Spotify API for album data. Features user authentication, live notifications, 5-star ratings, follows, likes, comments, playlist creation supporting 1000+ songs, and AI recommendations powered by Groq API.",
    tags: ["React", "CSS", "Supabase", "Spotify API", "Groq API"],
    link: "https://github.com/timothybernardo/muse",
  },
  {
    title: "StudySphere",
    desc: "Led a team of 4 to build a web app cataloging 42 campus study locations at Northeastern. Implemented user authentication, ratings, photo uploads, and a review system. Presented at the Oasis club showcase to CS professors.",
    tags: ["React", "CSS", "Supabase"],
    link: "https://github.com/Oasis-NEU/f25-group-26",
  },
  {
    title: "Klondike Solitaire",
    desc: "Engineered a Java-based Klondike Solitaire game with Basic and Whitehead variants using MVC architecture. Designed an abstract class hierarchy with factory pattern and authored 40+ JUnit tests achieving 100% coverage.",
    tags: ["Java", "JUnit", "MVC"],
    link: "https://github.com/timothybernardo/KlondikeSolitaire",
  },
];

export default projects;